import {QUERY_KEYS} from '@/queryClient'
import {httpGetJobStatusHistory} from '@/features/videos/services/video.http'
import {useQuery} from '@tanstack/react-query'

export const useGetJobStatusHistory = ({videoId, jobId}: {videoId: string; jobId: string}) =>
    useQuery({
        queryKey: [QUERY_KEYS.JOB_STATUS_HISTORY, videoId, jobId],
        queryFn: () => httpGetJobStatusHistory(videoId, jobId)
    })
